import { Component, Vue } from 'vue-property-decorator'
import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import { getMarketCooperationPrevLevel } from '@/api/common'
import { setMarketCooperationStatusById, getProjectAllGroupPriceListBySouCourseTypeId, getProjectAllListBySouCourseTypeId } from '@/api/market'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { souCoueTypeList } from '@/views/marketing/Cooperation-management/new-partner/data'
import { delNullProperty } from '@/utils/index'

@Component({
    filters: {
        timeFilter: (val: string) => (formatDate('yyyy-MM-dd hh:mm', new Date(val))),
        projectType: (souCourseTypeIdList: number[]) => {
            let souCourseTypeName = ''
            souCoueTypeList.forEach((item) => {
                if (souCourseTypeIdList.includes(item.value)) {
                    const nameArr = souCourseTypeName.split('+')
                    // 判断当前生成的名字中有几个 +
                    if (nameArr.length === souCourseTypeIdList.length) {
                        souCourseTypeName += item.label
                    } else {
                        souCourseTypeName += item.label + '+'
                    }
                }
            })
            return souCourseTypeName
        },
    }
})
export default class SeePartner extends Vue {
    // data
    checkedLeval = false //同步下级
    partnerName = ''
    id = 0
    operationShow = false // 操作日志显示隐藏
    data: any = ''
    dissertation_list = []
    type = ''
    reviewStatus = '' // 审批流状态
    status = 1 // 审批通过或者驳回时需要用到的状态  1- 通过 2-驳回
    // 可编辑字段
    editFiles = {
        name: '',
        marketCooperationId: '',
        source: '',
        types: '',
        contact: '',
        contactInfo: '',
        invoiceType: '',
        invoiceTitle: '',
        invoiceCode: '',
        invoiceBank: '',
        invoiceAccount: '',
        invoiceAddress: '',
        invoicePhone: '',
    }
    editFileList = []
    editFileIsRequired = false // 可编辑字段是否必填
    cancleReview = false // 撤回审批弹窗
    reviewDialog = false // 审批弹窗
    opinion = '' // 审批意见
    marketCooperationPrevLevelList = []// 上级合作伙伴列表

    projectTypeDialogShow = false
    projectTypeDialogTitle = ''
    projectTypeTableData = []
    projectTypeTableData_ = []
    projectPriceDialogShow = false
    editProjectTypePriceDialogShow = false
    projectPricetableData = [] // 项目列表
    projectPricetableHeadData = [
        { label: '项目编号', prop: 'souCourseIndex' },
        { label: '项目名称', prop: 'souCourseName' },
        // { label: '双课题备注', prop: 'doubleSouCourseName' },
        { label: '开课时间', prop: 'date' },
        { label: '导师名字', prop: 'souTeacherName' },
        { label: '项目定价', prop: 'souCoursePrice' },
        { label: '结算价', prop: 'price' },
    ]
    projectPriceFilterObj = {
        souCourseName: '',
        schoolBeginAt: [],
        souTeacherName: '',
        souCoursePrice: '',
        page: 1,
        limit: 20,
    }
    total = 0
    souCourseTypeId = undefined
    types= ''
    loading= false
    sourceList = [
        {label: 'BD自开拓', value: '0'},
        {label: '市场自开拓', value: '1'},
        {label: 'KA战略合作', value: '2'},
        {label: '高校业务部门', value: '3'},
        {label: '咨询平台', value: '4'},
        {label: '咨询自渠道', value: '5'}
    ]
    activities = []

    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }


    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any)=>{
        this.data = data.result.messageRemindInfo
        if (this.data.isAsync == '1') {
            this.checkedLeval = true
        }
        if (this.data.isAsync == '0') {
            this.checkedLeval = false
        }
        this.dissertation_list = this.data.marketCooperationProjectDissertationCommissionList
        this.dissertation_list.forEach(item => {
            if (item.commissionType == '') {
                return item.commissionType = '2'
            }
        })
        this.editFileList = this.data.editFileList || []
        // 可编辑字段对应
        this.editFileList.forEach(item => {
            if (item.cnFile === '关联上级') this.getMarketCooperationPrevLevel()
            item.file === 'name' && (this.editFiles.name = this.data.name)
            item.file === 'marketCooperationId' && (this.editFiles.marketCooperationId = this.data.marketCooperationId)
            item.file === 'source' && (this.editFiles.source = this.data.source)
            item.file === 'types' && (this.editFiles.types = this.data.types)
            item.file === 'contact' && (this.editFiles.contact = this.data.contact)
            item.file === 'contactInfo' && (this.editFiles.contactInfo = this.data.contactInfo)
            switch (item.file) {
                case 'invoiceType':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.types
                    break;
                case 'invoiceTitle':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.title
                    break;
                case 'invoiceCode':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.code
                    break;
                case 'invoiceBank':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.bank
                    break;
                case 'invoiceAccount':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.account
                    break;
                case 'invoiceAddress':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.address
                    break;
                case 'invoicePhone':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.phone
                    break;
                default:
                    break;
            }
        });
        if (this.editFileList && this.editFileList.length > 0) this.editFileIsRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.partnerName = this.data.name
        this.data.marketCooperationCommissionList.forEach(item => {
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => Number(id)))
        })
            this.activities =data.result.messageRemindInfo.messageReviewList
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    // 获取详细信息
    async getData() {
        const data: any = await getMessageReviewById(this.id,this.types)
        this.data = data.result
        if(this.data.isAsync == '1'){ this.checkedLeval = true}
        if(this.data.isAsync == '0'){ this.checkedLeval = false}
        this.dissertation_list = this.data.marketCooperationProjectDissertationCommissionList
        this.dissertation_list.forEach(item => {
            if (item.commissionType == '') {
                return item.commissionType = '2'
            }
        })
        this.editFileList = this.data.editFileList || []
        // 可编辑字段对应
        this.editFileList.forEach(item => {
            if (item.cnFile === '关联上级') this.getMarketCooperationPrevLevel()
            item.file === 'name' && (this.editFiles.name = this.data.name)
            item.file === 'marketCooperationId' && (this.editFiles.marketCooperationId = this.data.marketCooperationId)
            item.file === 'source' && (this.editFiles.source = this.data.source)
            item.file === 'types' && (this.editFiles.types = this.data.types)
            item.file === 'contact' && (this.editFiles.contact = this.data.contact)
            item.file === 'contactInfo' && (this.editFiles.contactInfo = this.data.contactInfo)
            switch (item.file) {
                case 'invoiceType':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.types
                    break;
                case 'invoiceTitle':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.title
                    break;
                case 'invoiceCode':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.code
                    break;
                case 'invoiceBank':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.bank
                    break;
                case 'invoiceAccount':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.account
                    break;
                case 'invoiceAddress':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.address
                    break;
                case 'invoicePhone':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.phone
                    break;
                default:
                    break;
            }
        });
        if(this.editFileList && this.editFileList.length > 0) this.editFileIsRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.partnerName = this.data.name
        this.data.marketCooperationCommissionList.forEach(item => {
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => Number(id)))
        })
    }

    // 获取可关联上级的数据
    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel({ id: this.data.id })
        this.marketCooperationPrevLevelList = data.marketCooperation
    }

    // 字段是否可编辑
    fileIsEdit(name: string): boolean {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.cnFile === name)
    }

    // 审批
    openReviewDialog(status: number) {
        this.status = status
        this.reviewDialog = true
    }

    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    // 审批通过确认
    async reviewDialogConfirm() {
        // 非空判断
        if (this.editFileIsRequired) {
            const bol = this.editFileList.every(item => {
                if (!this.editFiles[item.file]) this.$message.error(`${item.cnFile}不能为空`)
                return this.editFiles[item.file]
            })
            if (!bol) return
        }
        const param = {
            messageReviewId: this.id,
            status: this.status,
            opinion: this.opinion,
            form: {}
        }
        this.editFileList.forEach(item => param.form[item.file] = this.editFiles[item.file])
        await setMessageReviewUserByMessageReviewId(param)
        this.$message.success(`审批已${this.status === 1 ? '通过' : '驳回'}，页面即将关闭`)
        this.reviewDialog = false
        setTimeout(() => {
            window.close()
        }, 1500)
    }

    // 撤回审批
    async cancleReviewDialogConfirm() {
        await setMarketCooperationStatusById(this.data.id)
        this.$message.success('成功撤回审批，页面即将关闭')
        this.cancleReview = false
        setTimeout(() => {
            window.close()
        }, 1500)
    }

    async openProjectTypePriceDialog(souCourseTypeIdList: number[], item) {
        let projectAllGroupPriceList = item.projectAllGroupPriceList || []
        this.projectTypeDialogTitle = this.getMultipleSouCourseTypeName(souCourseTypeIdList)
        this.souCourseTypeId = souCourseTypeIdList
        if(projectAllGroupPriceList.length === 0) {
            const data = await getProjectAllGroupPriceListBySouCourseTypeId({ id: this.id + '', souCourseTypeIdList: souCourseTypeIdList  }) as unknown as { projectAllGroupPriceList: any[] }
            projectAllGroupPriceList = data.projectAllGroupPriceList
        }
        this.projectTypeTableData = projectAllGroupPriceList.filter(item => !item.isSetting)
        this.projectTypeTableData_ = projectAllGroupPriceList.filter(item => item.isSetting)
        this.projectTypeDialogShow = true
    }

    async editProjectTypePriceDialogShowChange(type: number) {
        if(type === 1) {
            this.getProjectAllListBySouCourseTypeId()
            this.projectTypeDialogShow = false
            this.projectPriceDialogShow = true
        }
        if(type === 2) {
            this.projectTypeDialogShow = true
            this.projectPriceDialogShow = false
        }
    }

    handleSizeChange(limit: number) {
        this.projectPriceFilterObj.limit = limit
        this.getProjectAllListBySouCourseTypeId()
    }

    handleCurrentChange(page) {
        this.projectPriceFilterObj.page = page
        this.getProjectAllListBySouCourseTypeId()
    }

    async getProjectAllListBySouCourseTypeId() {
        const obj = {}
        for(const key in this.projectPriceFilterObj) {
            obj[key] = this.projectPriceFilterObj[key]
        }
        if(this.projectPriceFilterObj.schoolBeginAt.length > 1 && Array.isArray(this.projectPriceFilterObj.schoolBeginAt)) {
            obj['schoolBeginAt'] = formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[1]))
        } else {
            obj['schoolBeginAt'] = ''
        }
        const { allNum, projectAllList } = await getProjectAllListBySouCourseTypeId(delNullProperty({
            ...obj,
            souCourseTypeIdList: this.souCourseTypeId,
            projectAllGroupPriceList: [...this.projectTypeTableData, ...this.projectTypeTableData_]
        })) as unknown as { allNum: number;  projectAllList: any[] }
        this.total = allNum
        this.projectPricetableData = projectAllList
    }

    handleBtn(id: number) {
        return menuBtn(id)
    }


    // 生成 souCourseTypeName
    getMultipleSouCourseTypeName(souCourseTypeIdList: number[]): string {
        let souCourseTypeName = ''
        souCoueTypeList.forEach((item) => {
            if (souCourseTypeIdList.includes(item.value)) {
                const nameArr = souCourseTypeName.split('+')
                // 判断当前生成的名字中有几个 +
                if (nameArr.length === souCourseTypeIdList.length) {
                    souCourseTypeName += item.label
                } else {
                    souCourseTypeName += item.label + '+'
                }
            }
        })
        return souCourseTypeName
    }

    previewContractUrl() {
        window.open(this.data.financeContractUrl, 'blank')
    }
}
